import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import 'bootstrap/dist/css/bootstrap.min.css';
import { captureVisit } from './utils/attribution';

// Remember an ad click (?gclid=...) before anything renders, so the quote form
// can report it even after the visitor has clicked through to another page.
captureVisit();

const container = document.getElementById('root');
const app = (
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// The Google Ads landing pages (/lp/*) are served pre-rendered: the finished
// HTML is already inside #root when the page arrives (scripts/prerender.js), so
// the visitor sees the content before any JavaScript has run. Hydrating adopts
// that HTML instead of wiping and redrawing it. Every other route still arrives
// with an empty #root and renders normally.
if (container.hasChildNodes()) {
  ReactDOM.hydrateRoot(container, app);
} else {
  ReactDOM.createRoot(container).render(app);
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
